import React, { ChangeEvent, FC } from "react";
import styles from "./SelectInput.module.css";

interface SelectInputProps {
    label?: string;
    value: string;
    onChange: (value: string) => void;
    options: { label: string; value: string }[];
    errorMessage?: string;
    id: string;
    placeholder?: string;
    disabled?: boolean; // New disabled prop
}

const SelectInput: FC<SelectInputProps> = ({
    label,
    value,
    onChange,
    options,
    errorMessage = "",
    id,
    placeholder = "Select an option...",
    disabled = false, // Default to false
}) => {
    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        onChange(event.target.value);
    };

    const isValid = !errorMessage;

    return (
        <div className={styles.container}>
            {label && <label htmlFor={id} className={styles.label}>{label}</label>}
            <select
                id={id}
                className={`${styles.selectInput} ${isValid ? "" : styles.invalid}`}
                value={value}
                onChange={handleChange}
                aria-invalid={!isValid}
                aria-describedby={!isValid ? `${id}-error` : undefined}
                disabled={disabled} // Apply disabled prop here
            >
                {/* Placeholder as the first option */}
                <option value="">
                    {placeholder}
                </option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            {!isValid && (
                <span id={`${id}-error`} className={styles.errorMessage}>
                    {errorMessage}
                </span>
            )}
        </div>
    );
};

export default SelectInput;
